import { render, staticRenderFns } from "./orderWxOtherShenpi.vue?vue&type=template&id=5658ad66&scoped=true"
import script from "./orderWxOtherShenpi.vue?vue&type=script&lang=js"
export * from "./orderWxOtherShenpi.vue?vue&type=script&lang=js"
import style0 from "./orderWxOtherShenpi.vue?vue&type=style&index=0&id=5658ad66&prod&scoped=true&lang=css"
import style1 from "./orderWxOtherShenpi.vue?vue&type=style&index=1&id=5658ad66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5658ad66",
  null
  
)

export default component.exports